import { App } from 'Features/app/App'
import { createRoot } from 'react-dom/client'
import {
  EventType,
  EventMessage,
  AuthenticationResult,
} from '@azure/msal-browser'
// `msalInstance` is constructed in its own module so route loaders that fire
// during webpack module evaluation (before this file's top-level statements
// run) still see a defined singleton. Re-exported so existing
// `import { msalInstance } from '../../'` consumers keep working.
import { msalInstance } from 'Features/auth/msal-instance'
export { msalInstance }

// `authRedirectInProgress` marks an in-flight AAD round-trip so the tenant
// bootstrap (Layout/TenantListPage) doesn't wipe or re-pick the tenant while
// we're bouncing through the IdP. It is set on the *outbound* leg, in
// `getToken` before `acquireTokenRedirect` — not here: this function runs on
// every load, and `handleRedirectPromise()` resolves `null` on an ordinary
// cached-session load, so setting it here left the flag stuck at 'true' for
// the whole session. That suppressed the redirect to /tenants, leaving
// `tenantId` unset and every API call without a `Tenant` header (the service
// then 422s on a null tenant).
const handleMsalRedirectPromise = async () => {
  try {
    return await msalInstance.handleRedirectPromise()
  } catch (error) {
    console.error('Error during redirect handling:', error)
    return null
  } finally {
    // Redirect handling has settled either way — the round-trip is over.
    sessionStorage.removeItem('authRedirectInProgress')
  }
}

msalInstance.initialize().then(() => {
  const accounts = msalInstance.getAllAccounts()
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0])
  }

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult
      const account = payload.account
      msalInstance.setActiveAccount(account)
      console.log('Login Success:', account)

      sessionStorage.removeItem('authRedirectInProgress')
    }
  })

  handleMsalRedirectPromise().then(() => {
    const domNode = document.getElementById('root') as HTMLElement
    const root = createRoot(domNode)
    root.render(<App />)
  })
})
